(function ClientLinkForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ClientLink',
	};

	$(document).ready(function documentReady() {
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('#clientlink-copy_from_address', $form).on('change', function showAddresses() {
			if ($(this).is(':checked')) {
				$('.addresses').removeClass('hidden');
			} else {
				$('.addresses').addClass('hidden');
			}
		});

		$('#clientlink-client_address_id', $form).on('change', function showFullAddress() {
			$('.address').addClass('hidden');
			$('#'+this.value+'.address').removeClass('hidden');
		}).trigger('change');
	};

}(jQuery, window.Adzuki || {}));
